import { useSelector } from 'react-redux';

import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';
import { selectSsnHidingEnabled } from '../../../redux/data/selectors';
import {
  makeLocalFieldsValidation,
  useFormState,
  useFormValidation,
} from '../../../hocs/useFormWithValidation';

export const initialState = {
  [PROFILE_FIELDS_TYPES.FIRST_NAME]: '',
  [PROFILE_FIELDS_TYPES.MIDDLE_NAME]: '',
  [PROFILE_FIELDS_TYPES.LAST_NAME]: '',
  [PROFILE_FIELDS_TYPES.NAME_SUFFIX]: '',
  [PROFILE_FIELDS_TYPES.GENDER]: '',
  [PROFILE_FIELDS_TYPES.DOB]: '',
  [PROFILE_FIELDS_TYPES.SSN]: '',
};

export function usePersonalInfoForm(errors) {
  const { formState, handleFormChange } = useFormState(initialState);
  const { validateErrors, clearErrors } = useFormValidation(errors);

  const ssnHidingEnabled = useSelector(selectSsnHidingEnabled);

  const isValid = makeLocalFieldsValidation([
    PROFILE_FIELDS_TYPES.FIRST_NAME,
    PROFILE_FIELDS_TYPES.LAST_NAME,
    PROFILE_FIELDS_TYPES.GENDER,
    PROFILE_FIELDS_TYPES.DOB,
    ...(!ssnHidingEnabled ? [PROFILE_FIELDS_TYPES.SSN] : []),
  ])(formState);

  return {
    formState,
    handleFormChange,
    validateErrors,
    clearErrors,
    isValid,
  };
}



// WEBPACK FOOTER //
// ./src/components/DependentForm/utils/usePersonalInfoFormState.js